'use client';

import { TransactionsScreen } from '@/components/transactions/screen/TransactionsScreen';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function TransactionsPage() {
  useChatPage('transactions');
  return (
    <div data-onboarding-transactions-page>
      {/* VER-260: the period picker lives in the filter aside on this route, so hide the
          header instance (route-level, matching every other page). */}
      <AppHeaderConfig hidePeriodPicker />
      <TransactionsScreen />
    </div>
  );
}
